/* svnty-taste.js: THE TASTE ENGINE v1, Tier 1 (02_architecture/TASTE_ENGINE_v1_SPEC.md sections 1 to 7 with A's amendments
 * of 2026-09-25 from KB_PERSONALIZATION_SYSTEMS section 6; A lane). The recorder, profile, catalog index cache, scorer,
 * ranker and renderer of PICKED FOR YOU (sections/svnty-picked.liquid) and RECENTLY VIEWED v2 (sections/svnty-recent.liquid);
 * it runs once however many sections tag it. Nothing leaves the device: no cookie, no request that writes, no name, email,
 * customer id or device id. Tier 2: the beacon and T.remote, wired by RECO_TIER2_WIRING_2026-09-26.md. D8-2 (R229): MANY ROOTS,
 * the search sheet seats a second, lazy pair (armed by svnty-search.js); see home().
 * STORAGE (D5-5): localStorage only once Shopify's customer privacy API has answered yes (window.SVNTY.consent, the
 * gate shared with svnty-suggest.js); until it answers, and whenever the banner asks and the shopper has not agreed,
 * the profile and the history live in this tab's sessionStorage, and a refusal removes what localStorage held. Safari
 * erases script storage after 7 days without a visit, so on iPhones the profile is
 * short-lived by design; Tier 2 carries the long profile for signed-in shoppers.
 * EVENTS ("svnty:taste:v1", 400 newest, {t, h, c, ts, ctx}, gone after 60 days): view 1 (again within 10 min: re 0.3),
 * dwell 0.5 (20 s on screen), colour 1 (its family only), save 3 (an unsave takes it back), add 5, remove -1, collection
 * 0.5, search 0.5 (only the words naming a type, color or world), nope -0.5 ("Not for me": its type, and the piece leaves
 * the row). Impressions (200, 7 days) feed fatigue only. RECENTLY VIEWED: {h, vid, c, ts} in "svnty:recent:v2";
 * "svnty:recently-viewed" carries over once.
 * THE SCORE of a candidate p (in stock; not on screen; not on the SIMILAR, WEAR IT WITH, PEOPLE ALSO VIEWED or RECENTLY
 * VIEWED rails; not "not for me"; not viewed in 60 days unless saved or added):
 *   aff_a(v)      = 0.6 visit + 0.4 long when this visit has events, else long; each the decayed mass on value v of
 *                   attribute a over the profile's largest for a (visit: events since the last 30 min gap, half-life 30 min;
 *                   long: every event, half-life 14 days)
 *   taste(p)      = sum_a W_a aff_a(p's best value) / sum_a W_a over the attributes p carries; W: type 1, color family 0.9,
 *                   world 0.8, season 0.5, price band 0.5, fit 0.4, collar 0.3, silhouette 0.3
 *   neighbours(p) = min(0.6, the largest decayed weight of a view, save or add in 14 days (not of the product on screen)
 *                   whose product lists p in sim, pairs or pal)
 *   context(p)    = 0.4 same world as the product on screen + 0.2 same season + 0.3 in its pairs or palette
 *   server(p)     = T.remote.scores[p] (Tier 2; null today, so 0)
 *   fatigue(p)    = max(0.4, 1 - 0.15 x impressions in 7 days since its last view); an impression is half the card on
 *                   screen for 1 s
 *   score(p)      = (0.55 taste + 0.2 neighbours + 0.15 context + 0.1 server) x fatigue; ties go to the newer piece
 * THE RANK: greedy MMR (lambda 0.7; distance 1 when types differ + 0.5 when color families differ; similarity 1 - d / 1.5),
 * never a third of one type or family; slot 6 of the 8 shown explores (the best piece of a type never viewed), chosen
 * against the visible eight, the spares after it; a type said "not for me" scores x (1 - 0.5 share), share = its nopes / 3.
 * THE ROW: 0 events, the learning row (one piece per type, newest first); 1 or 2, its first 2 or 4 cards are picks;
 * 3 and more on at least 2 distinct pieces, the picks, filled from the learning row.
 * THE COLLECTION PAGE (D5-9, R193, spec section 10): on a collection page that shows no products the rails stand under
 * the empty state with no product on screen; the context is the collection (data-svnty-taste-coll: its family's types
 * and its world) and the filters in the address (a color and a world count, a size is ignored): context(p) = 0.5 of the
 * page's types + 0.3 of its world + 0.2 in the filtered color, and the score weighs it 0.3 (taste 0.4). The learning
 * row seats the page's types and world first in its first round. A root marked data-svnty-empty-only shows only while
 * #ProductGridContainer holds the empty state; a filter that empties the grid fetches the sections into their slots. */
(() => {
  'use strict';
  /* THE CONSENT GATE (D5-5, Egypt's Decree 816: no profile of a shopper is kept on the device without consent). One object for
     the page, window.SVNTY.consent, defined by whichever of svnty-suggest.js and svnty-taste.js runs first (the same
     code in both files). state: 'unknown' until Shopify's customer privacy API has answered (Shopify.loadFeatures loads it),
     then 'yes' (the store needs no banner here, or analytics is allowed), 'pending' (the banner asks, no answer yet) or 'no'
     (the shopper declined). Only 'yes' writes localStorage; every other state keeps this tab's sessionStorage. on(fn) calls
     fn(state) at every change after it. */
  (function () {
    var SV = window.SVNTY = window.SVNTY || {};
    if (SV.consent) return;
    var o = SV.consent = { state: 'unknown', subs: [] };
    function decide() {
      var c = null, s = '';
      try { c = window.Shopify && window.Shopify.customerPrivacy; } catch (e) {}
      if (!c || typeof c.shouldShowBanner !== 'function' || typeof c.analyticsProcessingAllowed !== 'function') return;
      try {
        var v = typeof c.currentVisitorConsent === 'function' ? (c.currentVisitorConsent() || {}) : {};
        s = !c.shouldShowBanner() || c.analyticsProcessingAllowed() ? 'yes' : (v.analytics === 'no' ? 'no' : 'pending');
      } catch (e) { return; }
      if (s === o.state) return;
      o.state = s;
      o.subs.slice().forEach(function (f) { try { f(s); } catch (e) {} });
    }
    o.keep = function () { return o.state === 'yes'; };
    o.on = function (f) { o.subs.push(f); };
    o.decide = decide;
    decide();
    try {
      if (o.state === 'unknown' && window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) { if (!err) decide(); });
      }
    } catch (e) {}
    document.addEventListener('visitorConsentCollected', function () { setTimeout(decide, 0); });
    var n = 0, t = setInterval(function () { decide(); if (o.state !== 'unknown' || ++n > 60) clearInterval(t); }, 250);
  })();
  const S = window.SVNTY = window.SVNTY || {};
  if (S.taste) return;
  const T = S.taste = { remote: null }; /* TIER 2 HOOK: remote() sets {scores: {handle: 0 to 1}} from the pick API, or null */
  const D = 864e5, M = 6e4, now = () => Date.now();
  const K = { st: 'svnty:taste:v1', rv: 'svnty:recent:v2', old: 'svnty:recently-viewed', ix: 'svnty:taste:index', via: 'svnty:taste:via', ob: 'svnty:taste:outbox' };
  const WEV = { view: 1, re: 0.3, dwell: 0.5, colour: 1, save: 3, add: 5, remove: -1, collection: 0.5, search: 0.5, nope: -0.5 };
  const WAT = { ty: 1, cf: 0.9, w: 0.8, se: 0.5, pb: 0.5, fit: 0.4, col: 0.3, sl: 0.3 };
  const $ = (s, r = document) => r.querySelector(s), $$ = (s, r = document) => [...r.querySelectorAll(s)];
  /* CONSENT (D5-5): only the gate's yes keeps a profile in localStorage; unknown, pending and no stay in this tab's session */
  const mem = () => !S.consent.keep();
  let lastErr = '';
  const PERS = { [K.st]: 1, [K.rv]: 1 };
  const box = (k, s) => s || (mem() && PERS[k]) ? sessionStorage : localStorage;
  const get = (k, d, s) => { try { const v = JSON.parse(box(k, s).getItem(k)); return v == null ? d : v; } catch (e) { return d; } };
  const put = (k, v, s) => { try { box(k, s).setItem(k, JSON.stringify(v)); } catch (e) { lastErr = 'storage: ' + e.name; } };
  /* THE TWO STORES: the privacy API answers on its own time, so the profile and the history are read from BOTH stores and
     merged; they are written to the store consent allows. With consent the session copy folds into localStorage; without
     it localStorage is only ever reduced: cut(value) applies the shopper's removal to the localStorage copy alone (null
     removes the key), and the merged value is never written there. Every value read is checked against the current shape;
     a bad or old value is dropped. */
  const both = k => [localStorage, sessionStorage].map(x => { try { return JSON.parse(x.getItem(k)); } catch (e) { return null; } });
  const store = (k, v, cut) => {
    put(k, v);
    try {
      if (!mem()) sessionStorage.removeItem(k);
      else if (cut) { const raw = localStorage.getItem(k); if (raw != null) { let r = null; try { r = cut(JSON.parse(raw)); } catch (e) {} if (r == null) localStorage.removeItem(k); else localStorage.setItem(k, JSON.stringify(r)); } }
    } catch (e) {}
  };
  /* a cut of the profile: drop === true empties it, else the events drop(e) names leave it */
  const evCut = drop => drop && (s => drop === true || !(s && typeof s == 'object' && Array.isArray(s.ev)) ? null : Object.assign({}, s, { ev: s.ev.filter(e => !(e && drop(e))) }));
  /* one failure never takes the rails down: every entry point runs guarded and keeps the last error for the diagnostic */
  const fail = (n, e) => { lastErr = n + ': ' + ((e && e.message) || e); };
  const guard = (n, f) => (...a) => { try { const r = f(...a); return r && r.catch ? r.catch(e => fail(n, e)) : r; } catch (e) { fail(n, e); } };
  const ok = h => typeof h == 'string' && /^[^\s/?#\\]{1,255}$/.test(h) && h != '.' && h != '..' && h != 'gift-card';   /* P25: the gift card is never a piece in a rail (the refuter's P2-6) */
  const remap = h => { const v = (window.SVNTY_HANDLE_REMAP || {})[h]; return typeof v == 'string' ? v : h; };
  const dec = s => { try { return decodeURIComponent(s); } catch (e) { return ''; } };
  const hOf = u => dec((/\/products\/([^/?#]+)/.exec(u) || [])[1] || '');
  const decay = (ts, t, hl = 14 * D) => 0.5 ** ((t - ts) / hl);
  const share = (a, b) => (a || []).some(x => (b || []).includes(x));
  const top = o => Object.keys(o || {}).reduce((b, k) => b == null || o[k] > o[b] ? k : b, null);
  const max8 = r => Math.min(8, +r.dataset.svntyMax || 8);
  /* D8-2 MANY ROOTS (R229): the page's own rails and the search sheet's (sections/svnty-sheet-rails.liquid, seated in the
     sheet's slots by svnty-search.js). A root marked data-svnty-taste-lazy is drawn only once its host armed it (T.arm, the
     sheet opening or the idle prefetch); the sheet's roots exclude each other and nothing else (the page's rails are another
     surface), the page's roots exclude the page's rails as before. home() names the surface a root stands on. */
  const home = r => r.closest('[data-svnty-sheet-slot]') ? 'sheet' : 'page';
  const live = r => r.dataset.svntyTasteLazy == null || r.__armed;
  const pickedRoots = () => $$('[data-svnty-picked]').filter(live), recentRoots = () => $$('[data-svnty-taste-recent]').filter(live);
  const recentOf = r => $$('[data-svnty-taste-recent]').find(x => home(x) == home(r));
  const pickedOf = r => $$('[data-svnty-picked]').find(x => home(x) == home(r));
  const measure = () => { try { S.rows.measure(); } catch (e) {} };
  const node = h => { const t = document.createElement('template'); t.innerHTML = h; return t.content.firstElementChild; };
  /* a card that opens in color c: svnty-card-fetch renders it on the ?variant= color (picture, ring, links, quick-add); the
     hint keeps svnty-card.js on that color (forced for RECENTLY VIEWED: the color viewed beats a swatch tapped elsewhere) */
  const want = (x, c, force) => { x.dataset.svntyWantColor = c; if (force) x.dataset.svntyWantForce = ''; };

  /* THE STORE, read before every change: another tab, or the page this one came back to, may have written since */
  let st, IX, WORDS, lastDown, dw, pq = [], seenImp = {}, lastAdd = {};
  const pg = { h: '', vids: {} };
  const isEv = e => e && typeof e == 'object' && typeof e.t == 'string' && typeof e.ts == 'number' && e.ts > 0 && (e.h == null || typeof e.h == 'string') && (e.c == null || typeof e.c == 'string') && (e.k == null || (Array.isArray(e.k) && e.k.every(x => typeof x == 'string' && x.indexOf(':') > 0)));
  /* a timestamp from the future (a clock set wrong) is clamped to now: it can never outweigh today or sort first forever */
  const load = () => {
    const seen = {}, t = now();
    st = { v: 1, ev: [], imp: [] };
    both(K.st).forEach(s => {
      if (!(s && typeof s == 'object' && s.v == 1 && Array.isArray(s.ev))) return;
      ['mig', 'wl', 'sq', 'cart'].forEach(k => { if (st[k] == null && s[k] != null) st[k] = s[k]; });
      s.ev.forEach(e => { const id = isEv(e) && e.t + e.h + e.ts; if (id && !seen[id]) { seen[id] = 1; if (e.ts > t) e.ts = t; st.ev.push(e); } });
      (Array.isArray(s.imp) ? s.imp : []).forEach(x => { const id = x && typeof x.h == 'string' && typeof x.ts == 'number' && x.ts > 0 && 'i' + x.h + x.ts; if (id && !seen[id]) { seen[id] = 1; if (x.ts > t) x.ts = t; st.imp.push(x); } });
    });
    if (!Array.isArray(st.wl)) delete st.wl;
    if (!Array.isArray(st.sq)) delete st.sq;
    if (!st.cart || typeof st.cart != 'object' || Array.isArray(st.cart)) delete st.cart;
    st.ev.sort((a, b) => a.ts - b.ts);
  };
  /** commit(drop): writes the profile; drop (an event predicate, or true for all) is the shopper's removal, applied to the
      localStorage copy alone while there is no consent (evCut). */
  const commit = drop => {
    const t = now();
    drop = drop || st.less; delete st.less;
    st.ev = st.ev.filter(e => e.ts > t - 60 * D).sort((a, b) => a.ts - b.ts).slice(-400);
    st.imp = st.imp.filter(e => e.ts > t - 7 * D).slice(-200);
    store(K.st, st, evCut(drop));
  };
  /** beacon(e): TIER 2 (RECO_TIER2_WIRING_2026-09-26.md section 4): hands the event to svnty-suggest.js (window.SVNTY.reco),
      which sends it only with consent; a view opened from a rail carries "from:<rail>" so its co-view never counts as organic. */
  const RAIL = { picked: 'picked', similar: 'similar', look: 'look', 'also-viewed': 'also', pairs: 'pairs', palette: 'palette' };
  const beacon = e => {
    const o = { t: e.t, h: e.h, c: e.c, ts: e.ts, k: e.k };
    if (e.ctx && RAIL[e.ctx]) o.ctx = 'from:' + RAIL[e.ctx]; else if (e.ctx == 'quick') o.ctx = 'quick';
    if (S.reco) S.reco.push(o); else (S.recoQ = S.recoQ || []).push(o);
  };
  /* TIER 2: the server's scores for this session and page (RECO_TIER2_WIRING section 5); 5 minutes per page, 1.5 s budget,
     null on any failure (the device ranks alone, as before) */
  /* TASTE_CONSENT (2026-09-26): every answer is kept for its key, a cold or empty one and a failure too (1 minute; a warm
     one 5), and one request per key is in flight (a save never waits the 1.5 s budget again) */
  let remoteAt = 0, remoteKey = '', remoteP = null, remoteMissed = false;
  const remote = () => {
    const R = S.reco, s = R && R.sid ? R.sid() : '';
    if (!s) { remoteMissed = true; return Promise.resolve(T.remote = null); }
    const key = s + '|' + (pg.h || '');
    if (remoteKey == key && now() - remoteAt < (T.remote ? 5 : 1) * M) return Promise.resolve(T.remote);
    if (remoteP && remoteP.key == key) return remoteP;
    const q = new URLSearchParams({ s, cs: R.cs(), n: '24' }), dk = R.dk ? R.dk() : '';
    if (dk) q.set('dk', dk);
    if (R.qa) q.set('qa', '1');
    if (pg.h) q.set('p', pg.h);
    else if ($('[data-svnty-taste-home]')) q.set('page', 'home');   /* a home root is fed as a search root, named as the home */
    const ctl = window.AbortController ? new AbortController() : null, kill = setTimeout(() => ctl && ctl.abort(), 1500);
    const done = v => { if (remoteP && remoteP.key == key) remoteP = null; remoteAt = now(); remoteKey = key; return (T.remote = v); };
    remoteP = fetch('/apps/reco/pick?' + q, { credentials: 'same-origin', signal: ctl ? ctl.signal : undefined })
      .then(r => (r.ok ? r.json() : null))
      .then(j => {
        clearTimeout(kill);
        const l = j && Array.isArray(j.picks) ? j.picks : [], top = l.reduce((m, x) => Math.max(m, +x.s || 0), 0), scores = {}, why = {};
        l.forEach(x => { if (top > 0 && typeof x.h == 'string') { scores[x.h] = Math.max(0, Math.min(1, (+x.s || 0) / top)); if (x.why && typeof x.why.k == 'string') why[x.h] = x.why; } });
        const bought = j && Array.isArray(j.bought) ? j.bought.filter(h => typeof h == 'string') : [];
        return done(l.length || bought.length ? { scores, why, w: Math.max(0, Math.min(1, +(j && j.w) || 0)), bought, at: now() } : null);
      })
      .catch(() => { clearTimeout(kill); return done(null); });
    remoteP.key = key;
    return remoteP;
  };
  /** push(e): records one event {t, h, c, ts, ctx} and hands it to beacon(). */
  const push = e => { st.ev.push(e = { h: null, c: null, ts: now(), ctx: null, ...e }); beacon(e); };
  const last = (types, h) => st.ev.filter(e => e.h == h && types.includes(e.t)).pop();
  const recent = () => {
    const by = {};
    both(K.rv).forEach(l => (Array.isArray(l) ? l : []).forEach(r => {
      if (r && ok(r.h) && typeof r.ts == 'number' && r.ts > 0 && (!by[r.h] || by[r.h].ts < r.ts)) by[r.h] = { h: r.h, vid: typeof r.vid == 'number' ? r.vid : null, c: typeof r.c == 'string' ? r.c : null, ts: Math.min(r.ts, now()) };
    }));
    return Object.values(by);
  };
  const keep = (l, cut) => store(K.rv, l.sort((a, b) => b.ts - a.ts).slice(0, 24), cut);
  const remember = (h, vid, c, ts = now()) => keep(recent().filter(r => r.h != h).concat({ h, vid: vid || null, c: c || null, ts }));
  /* the history RECENTLY VIEWED shows: newest first, the product on screen and every piece the page's other rails show
     (railEx) left out, so nothing repeats across the rails (D5-5, B-16); PICKED FOR YOU excludes exactly this list */
  const shown = (max, ex = railEx()) => {
    const t = now(), seen = { [pg.h]: 1, ...ex }, o = [];
    recent().forEach(r => { const h = remap(r.h); if (ok(h) && !seen[h] && t - r.ts < 30 * D) { seen[h] = 1; o.push({ ...r, h }); } });
    return max ? o.slice(0, max) : o;
  };
  /* today's history carries over once: the old key's handles, newest first, become entries and views (the product on
     screen aside: the old recorder has just written it, and this page records its own view) */
  const migrate = () => {
    if (st.mig) return;
    st.mig = 1;
    const mine = recent(), have = {}, t0 = now() - 20 * M, old = get(K.old, []);
    mine.forEach(r => { have[r.h] = 1; });
    (Array.isArray(old) ? old : []).forEach((o, i) => {
      const h = remap(String((o && o.handle) || '')), ts = t0 - (i + 1) * M, m = /[?&]variant=(\d+)/.exec((o && o.url) || '');
      if (!ok(h) || have[h] || h == pg.h) return;
      have[h] = 1;
      mine.push({ h, vid: m ? +m[1] : null, c: null, ts });
      st.ev.push({ t: 'view', h, c: null, ts, ctx: 'carried' });
    });
    keep(mine);
  };

  /* THE RECORDER */
  const readPage = () => {
    const k = $('[data-svnty-taste-coll]'), sp = v => (v || '').split('|').filter(Boolean);
    if (k) pg.cc = { h: k.dataset.svntyTasteColl, ti: k.dataset.ti || '', ty: sp(k.dataset.ty), w: sp(k.dataset.w) };
    const r = $('[data-svnty-taste-ctx]'), d = r && r.dataset;
    if (!d) { if (/\/products\//.test(location.pathname)) pg.h = hOf(location.pathname); return; }
    Object.assign(pg, { h: d.svntyTasteCtx, cpos: +d.cpos || 0, vid: +d.vid || null, c: d.c || null, sel: d.sel == '1' });
    (d.vids || '').split(',').forEach(v => { pg.vids[v] = 1; });
  };
  const COLL = /^(?:\/[a-z]{2}(?:-[a-z]{2})?)?\/collections\/([^/?#]+)(\/products\/[^/?#]+)?\/?$/, SRCH = /\/search\/?$/;
  const coll = h => { const l = last(['collection'], h); if (ok(h) && h != 'all' && !(l && now() - l.ts < 30 * M)) push({ t: 'collection', h }); };
  /* the collection or search that led here, from the address and the referrer (a page that tags this file everywhere
     records collection and search pages themselves too); a query waits in memory until the index can read it */
  const context = () => {
    let r, m = COLL.exec(location.pathname);
    if (m && (m[2] || !pg.h)) coll(dec(m[1]));
    if (SRCH.test(location.pathname)) pq.push(new URLSearchParams(location.search).get('q'));
    try { r = new URL(document.referrer); } catch (e) { return; }
    if (!pg.h || r.origin != location.origin) return;
    if ((m = COLL.exec(r.pathname)) && !m[2]) coll(dec(m[1]));
    if (SRCH.test(r.pathname)) pq.push(r.searchParams.get('q'));
  };
  /* a view: the first in 10 minutes is a view, the next one re (0.3), and nothing more for that piece until 10 minutes
     after it (a reload is not interest); ctx is the rail it was opened from ("quick" for the CHOOSE OPTIONS door) */
  const view = (h, vid, c, sel, ctx) => {
    const t = now(), l = last(['view', 're'], h);
    if (!(l && t - l.ts < 10 * M && l.t == 're')) push({ t: l && t - l.ts < 10 * M ? 're' : 'view', h, c: sel ? c : null, ts: t, ctx });
    remember(h, vid, c, t);
  };
  const recordView = () => { const v = get(K.via, 0, 1); view(pg.h, pg.vid, pg.c, pg.sel, v && v.h == pg.h && now() - v.ts < 10 * M ? v.r : null); };
  const dwell = () => { let n = 0; dw = setInterval(() => { if (document.visibilityState == 'visible' && ++n >= 20) { clearInterval(dw); load(); const l = last(['dwell'], pg.h); if (!(l && now() - l.ts < 10 * M)) { push({ t: 'dwell', h: pg.h }); commit(); } } }, 1000); };
  /* THE QUICK VIEW: a product opened in the CHOOSE OPTIONS door (Trade's quick-add-modal) is a view in the color it opens
     on, and a color picked inside the door is a color pick of that product; the rails redraw when the door closes */
  let door = null;
  const doorOf = m => {
    const vs = $('variant-selects', m), url = (vs && vs.dataset.url) || ((m.openedBy && m.openedBy.getAttribute('data-product-url')) || ''), h = hOf(url);
    if (!ok(h)) return null;
    const d = { h, vids: {}, cpos: 0 }, sel = vs ? $$('select, fieldset', vs) : [];
    sel.forEach((f, i) => { if (!d.cpos && /colou?r/i.test(((f.querySelector('legend') || {}).textContent || '') + ' ' + (f.name || (f.querySelector('input') || {}).name || ''))) d.cpos = i + 1; });
    try { JSON.parse($('script[type="application/json"]', vs).textContent).forEach(v => { d.vids[v.id] = 1; }); } catch (e) {}
    const f = d.cpos && sel[d.cpos - 1], idIn = $('form input[name="id"]', m);
    d.c = f ? (f.tagName == 'SELECT' ? f.value : ((f.querySelector('input:checked') || {}).value || null)) : null;
    d.vid = idIn ? +idIn.value || null : null;
    return d;
  };
  const onDoor = m => {
    if (m.hasAttribute('open')) {
      if (m.__svntyQv) return;
      m.__svntyQv = 1;
      door = doorOf(m);
      /* the door's colour is where it opened, not a choice (B-22): the view is recorded in it without color mass */
      if (door) { load(); view(door.h, door.vid, door.c, false, 'quick'); commit(); }
    } else if (m.__svntyQv) {
      m.__svntyQv = 0; door = null;
      renderRecent(); renderPicked();
    }
  };
  /* THE DOOR'S OWN WORD (lane C, svnty-quickadd.js): a document event 'svnty:quickview' with detail {type: 'quickview',
     handle, colour, picked}; picked is true only when the shopper chose that colour inside the door, and only then is it a
     color pick of that product (once per product and colour in 10 s, so onVariant's own record is never doubled) */
  const onQuick = e => {
    const d = e && e.detail;
    if (!d || d.type != 'quickview' || d.picked !== true || !ok(d.handle) || typeof d.colour != 'string' || !d.colour) return;
    load();
    const l = last(['colour'], d.handle);
    if (l && l.c == d.colour && now() - l.ts < 1e4) return;
    push({ t: 'colour', h: d.handle, c: d.colour, ctx: 'quick' });
    commit();
  };
  /* a color picked on this product, or inside the open door on its product (any other variant is skipped) */
  const onVariant = e => {
    const v = e && e.data && e.data.variant, x = v && (pg.vids[v.id] ? pg : door && door.vids[v.id] ? door : null);
    if (!x) return;
    load();
    const c = x.cpos && v.options ? v.options[x.cpos - 1] : null;
    x.vid = v.id;
    if (c && c != x.c) { x.c = c; push({ t: 'colour', h: x.h, c }); }
    remember(x.h, v.id, x.c);
    commit();
  };
  /* the bag: an add answer is one line (or {items}); a whole cart (cart-items) is diffed, a line gone is a remove */
  const onCart = e => {
    const d = e && e.cartData;
    if (!d || typeof d != 'object') return;
    load();
    let cart = st.cart || {}, hit = false;
    const add = it => {
      const v = it.variant_id || it.id, c = ((it.options_with_values || []).find(o => /colou?r/i.test(o.name)) || {}).value;
      if (now() - (lastAdd[v] || 0) > 3000) { lastAdd[v] = now(); push({ t: 'add', h: it.handle, c, ctx: e.source }); hit = true; }
    };
    if (Array.isArray(d.items) && typeof d.item_count == 'number') {
      const next = {};
      d.items.forEach(it => { if (it && ok(it.handle)) { if (!cart[it.variant_id]) add(it); next[it.variant_id] = it.handle; } });
      Object.keys(cart).forEach(v => { if (!next[v]) { push({ t: 'remove', h: cart[v] }); hit = true; } });
      cart = next;
    } else (Array.isArray(d.items) ? d.items : [d]).forEach(it => { if (it && ok(it.handle)) { add(it); cart[it.variant_id || it.id] = it.handle; } });
    st.cart = cart;
    commit();
    /* P9 P1-1: a bag add or remove redraws the rows (350 ms, never under the finger) */
    if (hit) pickedRoots().forEach(r => { if (!(lastDown && r.contains(lastDown))) { clearTimeout(r.__t); r.__t = setTimeout(guard('picked', () => renderPicked(r)), 350); } });
  };
  /* the wishlist store against the last snapshot: a new handle is a save (at its own time), a gone one an unsave */
  const wishlist = () => {
    const w = get('svnty:wishlist'), items = {}, snap = Array.isArray(st.wl) ? st.wl : null;
    let ch = false;
    (Array.isArray(w && w.lists) ? w.lists : []).forEach(l => (Array.isArray(l && l.items) ? l.items : []).forEach(it => { if (it && ok(it.handle)) items[it.handle] = it; }));
    for (const h in items) {
      if (snap && snap.includes(h)) continue;
      const ts = +items[h].ts, c = String(items[h].opts || '').split(' / ').map(x => x.trim()).find(x => x && !/^(\d*x{0,4}[sml]|\d+(\.\d+)?|one size|os)$/i.test(x));
      push({ t: 'save', h, c, ts: ts > 0 && ts <= now() ? ts : now() });
      ch = true;
    }
    const gone = [];
    (snap || []).forEach(h => { if (!items[h]) { st.ev = st.ev.filter(e => !(e.t == 'save' && e.h == h)); push({ t: 'unsave', h }); gone.push(h); ch = true; } });
    if (gone.length) st.less = e => e.t == 'save' && gone.includes(e.h);
    st.wl = Object.keys(items);
    return ch;
  };
  const norm = s => String(s).toLowerCase().replace(/grey/g, 'gray').replace(/[^a-zÀ-ɏ]+/g, ' ').trim();
  const sing = w => String(w).toLowerCase().replace(/[^a-z]/g, '').replace(/s$/, '');
  const keysOf = (s, I) => {
    let n = ' ' + norm(s) + ' ';
    const o = [];
    I.cn.forEach(c => { if (n.includes(' ' + c.n + ' ')) { n = n.replace(' ' + c.n + ' ', ' '); o.push('cf:' + c.f); } });
    const tk = n.trim().split(/\s+/);
    for (let i = 0; i < tk.length; i++) {
      const two = tk[i + 1] && I.tyk[sing(tk[i] + tk[i + 1])], one = I.tyk[sing(tk[i])];
      if (two) { o.push('ty:' + two); i++; } else if (one) o.push('ty:' + one); else if (/^(live|work|play)$/.test(tk[i])) o.push('w:' + tk[i].toUpperCase());
    }
    return [...new Set(o)].slice(0, 6);
  };
  const flush = I => pq.splice(0).filter(Boolean).forEach(s => {
    const k = keysOf(s, I);
    if (k.length && !st.ev.some(e => e.t == 'search' && String(e.k) == String(k) && now() - e.ts < 30 * M)) push({ t: 'search', k });
  });

  /* THE CATALOG INDEX (sections/svnty-taste-index.liquid); cache v 4 since SHEET_S (2026-09-26): the items carry cn, the names the site prints */
  /** index(): a promise of the prepared index: the cache while fresh (6 hours, the page's product count, the product on
      screen known), else one fetch of every page of 250; null when neither exists. */
  const index = () => {
    if (IX) return IX;
    const d = ($('[data-svnty-index]') || {}).dataset || {}, n = +d.svntyCount || 0, t = now();
    let c = get(K.ix);
    if (!(c && typeof c == 'object' && c.v == 4 && Array.isArray(c.items))) c = null;
    else c.items = c.items.filter(p => p && typeof p == 'object' && ok(p.h));
    const fresh = c && c.at > 0 && t - c.at < 216e5 && c.items.length == c.count && (!n || c.count == n) && !(pg.h && !c.items.some(p => p.h == pg.h) && t - c.at > 10 * M);
    if (!fresh && !d.svntyIndex) return Promise.resolve(prep(c));
    return IX = fresh ? Promise.resolve(prep(c)) : pull(d.svntyIndex, c).then(prep, () => prep(c));
  };
  const pull = async (url, prev) => {
    let items = [], tags = [], count = 0, pages = 1;
    for (let n = 1; n <= pages && n <= 20; n++) {
      const r = await fetch(url + (n > 1 ? '&page=' + n : ''), { credentials: 'same-origin' });
      const m = r.ok && /data-svnty-taste-index>([\s\S]*?)<\/script>/.exec(await r.text());
      if (!m) throw new Error('index');
      const d = JSON.parse(m[1]);
      items = items.concat(d.items || []); tags.push(d.etag); count = d.count; pages = d.pages;
    }
    const etag = tags.join(), x = prev && prev.etag == etag ? prev : { v: 4, etag, count, items: families(items) };
    x.at = now();
    put(K.ix, x);
    return x;
  };
  /* THE COLOR FAMILY: each measured hex binned in OKLCH into 12 hue families of 30 degrees, black, white, gray and beige;
     each color name then takes its catalog-wide majority, so one name is one family whatever a photo measured */
  const fam = hex => {
    if (!/^#[0-9a-f]{6}$/i.test(hex || '')) return null;
    const n = parseInt(hex.slice(1), 16), [r, g, b] = [n >> 16, n >> 8 & 255, n & 255].map(v => (v /= 255) <= 0.04045 ? v / 12.92 : ((v + 0.055) / 1.055) ** 2.4);
    const l = Math.cbrt(0.4122 * r + 0.5363 * g + 0.0514 * b), m = Math.cbrt(0.2119 * r + 0.6807 * g + 0.1074 * b), s = Math.cbrt(0.0883 * r + 0.2817 * g + 0.63 * b);
    const L = 0.2105 * l + 0.7936 * m - 0.0041 * s, A = 1.978 * l - 2.4286 * m + 0.4506 * s, B = 0.0259 * l + 0.7828 * m - 0.8087 * s;
    const C = Math.hypot(A, B), H = (Math.atan2(B, A) * 180 / Math.PI + 360) % 360;
    if (C < 0.025 || (L < 0.2 && C < 0.03)) return L < 0.4 ? 'black' : L > 0.88 ? 'white' : 'gray';
    if (C < 0.07 && H >= 30 && H <= 100 && L > 0.72) return 'beige';
    return 'h' + Math.floor((H + 15) % 360 / 30);
  };
  const families = items => {
    const vote = {};
    items.forEach(p => (p.co || []).forEach((n, i) => { const f = fam((p.cx || [])[i]), v = vote[n] = vote[n] || {}; if (f) v[f] = (v[f] || 0) + 1; }));
    items.forEach(p => { p.cf = (p.co || []).map(n => top(vote[n])); });
    return items;
  };
  const prep = x => {
    if (!x) return null;
    x.items = x.items.filter(p => p && typeof p == 'object' && ok(p.h));
    x.items.forEach(p => { ['co', 'cf', 'cx', 'cv', 'ca', 'w', 'se', 'sim', 'pairs', 'pal'].forEach(k => { if (!Array.isArray(p[k])) p[k] = []; }); });
    const I = { items: x.items, by: {}, tyk: {}, cn: [], cfam: {}, q: [] }, pr = x.items.map(p => p.pr || 0).sort((a, b) => a - b);
    x.items.forEach(p => {
      I.by[p.h] = p;
      if (p.ty) I.tyk[sing(p.ty)] = p.ty;
      (p.co || []).forEach((n, i) => { if (p.cf[i] && !I.cfam[n]) { I.cfam[n] = p.cf[i]; I.cn.push({ n: norm(n), f: p.cf[i] }); } });
    });
    I.cn.sort((a, b) => b.n.length - a.n.length);
    for (let i = 1; i < 5; i++) I.q.push(pr[Math.floor(pr.length * i / 5)] || 0);
    return I;
  };
  const band = (pr, I) => String(I.q.filter(t => pr >= t).length);

  /* THE PROFILE */
  /** profile(I): the decayed event mass per attribute value, long (raw, half-life 14 days) and this visit's (visit,
      half-life 30 min), normalised per attribute by its maximum and blended into n; the types viewed (seen). */
  const profile = I => {
    const t = now(), P = { raw: {}, visit: {}, n: {}, seen: {}, k: {} };
    let vs = t, live = 0;
    for (let i = st.ev.length; i--;) { if (vs - st.ev[i].ts > 30 * M) break; vs = st.ev[i].ts; }
    for (const a in WAT) { P.raw[a] = {}; P.visit[a] = {}; P.n[a] = {}; P.k[a] = {}; }
    st.ev.forEach(e => {
      const b = WEV[e.t] || 0, p = I.by[remap(e.h || '')], w = b * decay(e.ts, t), wv = e.ts >= vs ? b * decay(e.ts, t, 30 * M) : 0;
      const add = (a, v) => { if (v == null || v === '' || !P.raw[a]) return; P.raw[a][v] = (P.raw[a][v] || 0) + w; if (b > 0) P.k[a][v] = (P.k[a][v] || 0) + 1; if (wv) { live = 1; P.visit[a][v] = (P.visit[a][v] || 0) + wv; } };
      if (!b) return;
      if (e.t == 'search') return (e.k || []).forEach(k => { if (typeof k == 'string' && k.indexOf(':') > 0) add(k.split(':')[0], k.slice(k.indexOf(':') + 1)); });
      if (e.t == 'collection') return collKeys(e.h, I).forEach(k => add(k[0], k[1]));
      if (!p) return;
      if (e.t == 'nope') return add('ty', p.ty);
      /* a save carries the printed name ("Blue stripe / M", THE STRIPE NAME): it resolves to its own value through cn, so a
         stripe keeps its color weight and stays apart from the solid of the same name (lane STRIPE_NAME's item 2) */
      let i = e.c ? (p.co || []).indexOf(e.c) : -1;
      if (i < 0 && e.c && p.cn) i = p.cn.indexOf(e.c);
      const f = e.c && (i >= 0 ? p.cf[i] : I.cfam[e.c]);
      if (f) add('cf', f);
      if (e.t == 'colour') return;
      if (/^(view|re|dwell)$/.test(e.t)) P.seen[p.ty] = 1;
      add('ty', p.ty); add('pb', band(p.pr, I)); add('fit', p.fit); add('col', p.col); add('sl', p.sl);
      (p.w || []).forEach(x => add('w', x));
      (p.se || []).forEach(x => add('se', x));
    });
    const nm = m => { const mx = Math.max(0, ...Object.values(m)); return v => mx > 0 ? Math.max(0, m[v] || 0) / mx : 0; };
    for (const a in WAT) {
      const L = nm(P.raw[a]), V = nm(P.visit[a]);
      Object.keys({ ...P.raw[a], ...P.visit[a] }).forEach(v => { P.n[a][v] = live ? 0.6 * V(v) + 0.4 * L(v) : L(v); });
    }
    return P;
  };
  const collKeys = (h, I) => {
    const l = String(h || '').toLowerCase(), o = [];
    if (/^(live|work|play)$/.test(l)) o.push(['w', l.toUpperCase()]);
    if (I.tyk[sing(l)]) o.push(['ty', I.tyk[sing(l)]]);
    if (/winter/.test(l)) o.push(['se', 'Winter']);
    if (/summer/.test(l)) o.push(['se', 'Summer']);
    return o;
  };
  /* the collection page's context: its family's types, its world, and the filters of the address (color, world, type) */
  const ccx = I => {
    const c = pg.cc;
    if (!c || pg.h) return null;
    const o = { ty: {}, w: {}, cf: {}, se: {}, ti: c.ti, h: c.h };
    c.ty.forEach(t => { o.ty[t] = 1; }); c.w.forEach(w => { o.w[w] = 1; });
    collKeys(c.h, I).forEach(k => { o[k[0]][k[1]] = 1; });
    new URLSearchParams(location.search).forEach((v, k) => {
      if (!/^filter\./.test(k)) return;
      if (/colou?r/i.test(k) && I.cfam[v]) o.cf[I.cfam[v]] = 1;
      else if (/product_type/.test(k) && I.tyk[sing(v)]) o.ty[I.tyk[sing(v)]] = 1;
      else if (/^(live|work|play)$/i.test(v)) o.w[v.toUpperCase()] = 1;
    });
    return o;
  };

  /* THE SCORE AND THE RANK */
  const taste = (p, P, I) => {
    let num = 0, den = 0;
    const parts = {};
    [['ty', [p.ty]], ['cf', p.cf], ['w', p.w], ['se', p.se], ['pb', [band(p.pr, I)]], ['fit', [p.fit]], ['col', [p.col]], ['sl', [p.sl]]].forEach(([k, vals]) => {
      vals = (vals || []).filter(v => v != null && v !== '');
      if (!vals.length) return;
      parts[k] = WAT[k] * Math.max(...vals.map(v => P.n[k][v] || 0));
      den += WAT[k]; num += parts[k];
    });
    return { v: den ? num / den : 0, parts, den: den || 1 };
  };
  /* THE COLOR A PICK OPENS IN: any available colorway; MMR takes the most preferred (the shopper's strongest family) that
     the cap allows, and with no preference the one least like the picks before it, so the row is varied by colorway too */
  const opts = (p, P, cc) => {
    const o = (p.co || []).map((c, i) => ({ c, i, f: p.cf[i], vid: p.cv[i] || null, a: (P.n.cf[p.cf[i]] || 0) + (cc && cc.cf[p.cf[i]] ? 1 : 0) })).filter(x => p.ca[x.i]).sort((x, y) => y.a - x.a || x.i - y.i);
    return o.length ? o : [{ i: 0, a: 0, f: null }];
  };
  const fit = (list, c) => {
    let o = null, os = Infinity;
    if (list.filter(x => x.ty == c.ty).length > 1) return null;
    c.opts.forEach(x => {
      if (x.f && list.filter(y => y.f == x.f).length > 1) return;
      const s = Math.max(0, ...list.map(y => 1 - ((c.ty != y.ty) + (x.f != y.f) / 2) / 1.5));
      if (!o || x.a > o.a || (x.a == o.a && s < os)) { o = x; os = s; }
    });
    return o && { o, s: os };
  };
  const take = (c, o) => Object.assign(c, { c: o.c, f: o.f, vid: o.vid, want: !!o.c });
  const mmr = (pool, k) => {
    const out = [], rest = pool.slice();
    while (out.length < k) {
      let bi = -1, bv = -Infinity, bo;
      rest.forEach((c, i) => { const r = fit(out, c); if (r && 0.7 * c.score - 0.3 * r.s > bv) { bv = 0.7 * c.score - 0.3 * r.s; bi = i; bo = r.o; } });
      if (bi < 0) break;
      out.push(take(rest.splice(bi, 1)[0], bo));
    }
    return out;
  };
  /** rank(I, ex, n): every candidate scored, best first, with its parts and fatigue (all), and the list of up to n (MMR,
      the caps, the explore slot at position 6), each with its reason in words (why). ex = handles the page already shows. */
  const rank = (I, ex, n) => {
    const P = profile(I), t = now(), cur = I.by[pg.h], cc = !cur && ccx(I), wt = cc ? 0.4 : 0.55, wc = cc ? 0.3 : 0.15, view = {}, own = {}, nb = {}, imp = {}, all = [], srv = T.remote && T.remote.scores;
    /* TIER 2 (svnty-reco 1.3): the server's term weighs 0.1 + 0.3 w, w = its profile's credibility n / (n + 4); a piece the
       shopper bought (the orders webhook) stays out for 30 days */
    const sw = 0.1 + 0.3 * (T.remote ? T.remote.w || 0 : 0), bought = {}, swhy = (T.remote && T.remote.why) || {};
    ((T.remote && T.remote.bought) || []).forEach(h => { bought[remap(h)] = 1; });
    const nopes = {}, nopeNb = {};
    st.ev.forEach(e => {
      const h = remap(e.h || ''), s = I.by[h];
      if (/^(view|re|dwell)$/.test(e.t)) view[h] = Math.max(view[h] || 0, e.ts);
      if (e.t == 'save' || e.t == 'add') own[h] = 1;
      if (e.t == 'nope' && s) { nopes[s.ty] = (nopes[s.ty] || 0) + 1; (s.sim || []).forEach(x => { nopeNb[x] = 1; }); }
      if (!s || h == pg.h || !/^(view|re|save|add)$/.test(e.t) || t - e.ts > 14 * D) return;
      const w = Math.min(0.6, WEV[e.t] * decay(e.ts, t));
      ['sim', 'pairs', 'pal'].forEach(r => (s[r] || []).forEach(x => { if (!nb[x] || nb[x].w < w || (nb[x].w == w && /save|add/.test(e.t))) nb[x] = { w, s, t: e.t, r }; }));
    });
    st.imp.forEach(x => { if (t - x.ts < 7 * D && !(view[x.h] > x.ts)) imp[x.h] = (imp[x.h] || 0) + 1; });
    I.items.forEach(p => {
      if (!p.av || p.h == pg.h || ex[p.h] || bought[p.h] || (view[p.h] && !own[p.h])) return;
      const tp = taste(p, P, I), pa = {}, b = nopeNb[p.h] ? null : nb[p.h], nv = b ? b.w : 0, fat = Math.max(0.4, 1 - 0.15 * (imp[p.h] || 0)) * (1 - 0.5 * Math.min(1, (nopes[p.ty] || 0) / 3));
      let cx = 0;
      for (const k in tp.parts) pa[k] = wt * tp.parts[k] / tp.den;
      if (cc) {
        if (cc.ty[p.ty]) { cx += 0.5; pa.xt = wc * 0.5; }
        if (share(p.w, Object.keys(cc.w))) { cx += 0.3; pa.xw = wc * 0.3; }
        if (p.cf.some((f, i) => cc.cf[f] && p.ca[i])) { cx += 0.2; pa.xc = wc * 0.2; }
      }
      if (cur && share(p.w, cur.w)) { cx += 0.4; pa.cw = 0.06; }
      if (cur && share(p.se, cur.se)) { cx += 0.2; pa.cs = 0.03; }
      if (cur && (cur.pairs || []).concat(cur.pal || []).includes(p.h)) { cx += 0.3; pa.cp = 0.045; }
      if (nv) pa.nb = 0.2 * nv;
      const sv = srv ? +srv[p.h] || 0 : 0, sy = swhy[p.h], ss = sy && sy.h && I.by[remap(sy.h)];
      if (sv) pa.sv = sw * sv;
      all.push({ p, h: p.h, ty: p.ty, own: !!own[p.h], opts: opts(p, P, cc), nb: b, parts: pa, fat, sw: ss && /^(saved|bag|goes|goes_viewed|viewed)$/.test(sy.k) ? { k: sy.k, ti: ss.ti } : null, score: (wt * tp.v + 0.2 * nv + wc * cx + sw * sv) * fat });
    });
    all.sort((a, b) => b.score - a.score || b.p.new - a.p.new);
    /* THE EXPLORE SLOT (B-08): chosen against the eight the row shows (less the last one, which it pushes to the spares), so
       the caps can always seat it; it takes slot 6 and the spares follow */
    let list = mmr(all, n);
    const k = Math.min(8, n), V = list.slice(0, k), rest = list.slice(k), base = V.length >= k ? V.slice(0, k - 1) : V;
    const x = all.find(c => !P.seen[c.ty] && !base.includes(c) && fit(base, c));
    if (x) {
      take(x, fit(base, x).o).explore = true;
      const vi = V.indexOf(x), ri = rest.indexOf(x);
      if (vi >= 0) V.splice(vi, 1); else { if (ri >= 0) rest.splice(ri, 1); if (V.length >= k) rest.unshift(V.pop()); }
      V.splice(Math.min(5, V.length), 0, x);
      list = V.concat(rest).slice(0, n);
    }
    list.forEach(c => { c.why = why(c, P, cur, cc); });
    return { list, all, profile: P };
  };
  /* the learning row: in stock, one piece per type, newest first, then a second round */
  const learn = (I, ex) => {
    const pool = I.items.filter(p => p.av && p.h != pg.h && !ex[p.h]).sort((a, b) => (b.pa || 0) - (a.pa || 0)), n = {};
    let o = [];
    for (let r = 0; r < 3; r++) pool.forEach(p => { if ((n[p.ty] || 0) == r && !o.includes(p)) { o.push(p); n[p.ty] = r + 1; } });
    /* a collection page seats its own types, then its world, first in the first round (one per type still) */
    const cc = ccx(I), k = Object.keys(n).length;
    if (cc) { const s = p => (cc.ty[p.ty] ? 2 : 0) + (share(p.w, Object.keys(cc.w)) ? 1 : 0); o = o.slice(0, k).sort((a, b) => s(b) - s(a)).concat(o.slice(k)); }
    /* P9 P2-3: an owned learning card says so */
    const cart = st.cart || {}, inBag = h => Object.keys(cart).some(v => cart[v] == h), onList = h => Array.isArray(st.wl) && st.wl.includes(h);
    return o.map(p => ({ p, h: p.h, ty: p.ty, why: (inBag(p.h) && fill('why_in_bag')) || (onList(p.h) && fill('why_on_wishlist')) || (p.new && W('probe_new')) || fill('probe_type', { types: lc(p.ty) }) }));
  };

  /* THE WHY: the reasons the score's terms support, strongest first (fit, collar, silhouette and price count half), each
     used only when every word it needs is there and it reads as a sentence; else the next, and last "Picked for you" */
  const W = k => {
    if (!WORDS) try { WORDS = JSON.parse($('[data-svnty-taste-words]').textContent) || {}; } catch (e) { WORDS = {}; }
    return WORDS[k] || '';
  };
  const fill = (k, v = {}) => {
    let out = W(k), gap = false;
    out = out.replace(/\{(\w+)\}/g, (x, n) => { const s = String(v[n] == null ? '' : v[n]).trim(); if (!s) gap = true; return s; }).replace(/\s+/g, ' ').trim();
    return !gap && /^[A-Z]/.test(out) && !/[{}]/.test(out) ? out : '';
  };
  /* a type inside a sentence: lower case, except a single letter before a hyphen (T-shirts) */
  const lc = t => String(t || '').split(' ').map(w => /^.-/.test(w) ? w : w.toLowerCase()).join(' ');
  /* a world code in a sentence: Live, Work, Play */
  const tc = w => w ? String(w).charAt(0).toUpperCase() + String(w).slice(1).toLowerCase() : '';
  /* the reason never over-claims (B-20): a color is "one you keep choosing" only after 2 or more events on its family; a
     piece the shopper already owns in the bag or on the wishlist says so; the last word is always true of the piece on
     screen (the same world, the same season) or of the pick itself (new in, or which of our types it is) */
  const why = (c, P, cur, cc) => {
    if (c.explore && fill('why_explore')) return fill('why_explore');
    /* THE STRIPE NAME (R239; lane STRIPE_NAME's item 1, applied by SHEET_S): the reason prints the color as the site names it
       ("Blue stripe", the index's cn), the matching keeps the store's value */
    const cname = x => { const i = (c.p.co || []).indexOf(x); return (i >= 0 && c.p.cn && c.p.cn[i]) || x; };
    const pa = c.parts, p = c.p, b = c.nb, h = {}, types = lc(p.ty), color = P.n.cf[c.f] > 0 && (P.k.cf[c.f] || 0) >= 2 ? cname(c.c) : '';
    if (c.own) {
      const cart = st.cart || {}, inBag = Object.keys(cart).some(v => cart[v] == p.h), onList = Array.isArray(st.wl) && st.wl.includes(p.h);
      const r = (inBag && fill('why_in_bag')) || (onList && fill('why_on_wishlist'));
      if (r) return r;
    }
    for (const q in pa) if (pa[q] > 0) h[q] = /^(fit|col|sl|pb)$/.test(q) ? pa[q] / 2 : pa[q];
    const say = {
      nb: () => b && fill(b.r == 'sim' ? { save: 'why_saved', add: 'why_bag' }[b.t] || 'why_viewed' : b.t == 'save' || b.t == 'add' ? 'why_goes' : 'why_goes_viewed', { title: b.s.ti }),
      sv: () => c.sw && fill('why_' + c.sw.k, { title: c.sw.ti }),
      ty: () => (h.cf && fill('why_type_color', { types, color })) || fill('why_type', { types }),
      cf: () => (h.ty && fill('why_type_color', { types, color })) || fill('why_color', { color }),
      w: () => (p.new && fill('why_new_world')) || fill('why_world', { world: tc((p.w || []).find(x => P.n.w[x] > 0)) }),
      se: () => { const se = (p.se || []).find(x => P.n.se[x] > 0) || ''; return /all/i.test(se) ? fill('why_all_season') : fill('why_season', { season: se.toLowerCase() }); },
      pb: () => fill('why_price'), cw: () => fill('why_this_world'), cs: () => fill('why_this_season'), cp: () => fill('why_this_goes'),
      xt: () => sing(cc.ti) == sing(p.ty) ? fill('probe_type', { types }) : fill('why_coll_type', { collection: cc.ti, types }),
      xw: () => fill('why_coll_world', { collection: cc.ti }), xc: () => fill('why_filter_color', { color: cname(c.c) })
    };
    for (const k of Object.keys(h).sort((x, y) => h[y] - h[x])) { const r = say[k] && say[k](); if (r) return r; }
    return (cur && share(p.w, cur.w) && fill('why_this_world')) || (cur && share(p.se, cur.se) && fill('why_this_season'))
      || (p.new && W('probe_new')) || fill('probe_type', { types }) || W('probe_new');
  };

  /* THE CARDS: THE CARD v2 through sections/svnty-card-fetch.liquid, at most 8 requests in flight */
  const CARDS = {}, waitq = [];
  let busy = 0;
  const pump = () => { while (busy < 8 && waitq.length) waitq.shift()(); };
  const card = (root, h, vid) => CARDS[h + vid] || (CARDS[h + vid] = new Promise(res => {
    waitq.push(() => {
      busy++;
      fetch((root.dataset.svntyFetch || '/products/') + encodeURIComponent(h) + '?' + (vid ? 'variant=' + vid + '&' : '') + 'section_id=svnty-card-fetch', { credentials: 'same-origin' })
        .then(r => r.ok ? r.text() : '')
        .then(t => {
          const li = t && new DOMParser().parseFromString(t, 'text/html').querySelector('li[data-svnty-card-fetch]');
          if (!li || !li.dataset.handle) return null;
          $$('link[rel="stylesheet"]', li).forEach(l => { try { if ($('link[href="' + l.getAttribute('href') + '"]')) l.remove(); } catch (e) {} });
          return li;
        })
        .catch(() => null)
        .then(li => { busy--; if (!li) delete CARDS[h + vid]; res(li); pump(); });
    });
    pump();
  }));
  /* one write per rail; the old cards' quick-add modals (parked at the end of body by Trade) leave with them. D6-16: every
     card now opens the page's ONE door (#SvntyDoor, in the header slab), which never leaves */
  const write = (rail, html) => {
    $$('modal-opener[data-modal]', rail).forEach(o => { try { const m = $(o.dataset.modal); if (m && m.id !== 'SvntyDoor' && !rail.contains(m) && !m.hasAttribute('open')) m.remove(); } catch (e) {} });
    rail.innerHTML = html;
  };
  /* P17-9 (audit P1-1): a root that has decided wears data-svnty-settled; the bag reserves a picked root's room until then */
  const settle = root => { if (root && !root.hasAttribute('data-svnty-settled')) root.setAttribute('data-svnty-settled', ''); };
  const off = root => { write($('[data-svnty-rail]', root), ''); root.hidden = true; settle(root); };
  /* THE HOME'S EMPTY STATES (06:22): on the home RECENTLY VIEWED never vanishes (no history: the heading and the
     universal line, no cards) and PICKED FOR YOU with no consent and no index keeps its heading and the learning line.
     Every other host hides the root. */
  const emptyRecent = root => {
    write($('[data-svnty-rail]', root), '');
    $$('[data-svnty-taste-empty]', root).forEach(e => { e.hidden = false; });
    root.hidden = false;
    measure();
  };
  const coldOnly = root => {
    const row = $('[data-svnty-picked-list]', root);
    if (row) { write($('[data-svnty-rail]', row), ''); row.hidden = true; }
    $$('[data-svnty-cold]', root).forEach(e => { e.hidden = false; });
    root.hidden = false;
  };
  /* THE EMPTY PAGE GATE (D5-9): a root marked data-svnty-empty-only shows only while the grid holds the empty state */
  const shut = root => root.dataset.svntyEmptyOnly != null && !$('#ProductGridContainer .svnty-empty') && (root.__run = (root.__run || 0) + 1, off(root), 1);
  /* what the page's rails show: SIMILAR, PEOPLE ALSO VIEWED and WEAR IT WITH's row on screen (a colour's row not yet
     fetched names its pieces in data-ww-handles); every colour's row with all = true */
  /* P17-3 (2026-09-30): on the bag, TAILORED FOR YOU also gives up what the bag holds and what COMPLETES YOUR BAG shows
     (it offered the Oxford Shirt in the bag, "In your bag") */
  const railEx = all => {
    const ex = {}, ww = all ? '[data-svnty-look] [data-ww-color]' : '[data-svnty-look] [data-ww-color]:not([hidden])';
    $$('[data-svnty-home-rail] a[href*="/products/"],[data-svnty-similar] a[href*="/products/"],[data-svnty-also-viewed] a[href*="/products/"],[data-svnty-bag] .svnty-bag__lines a[href*="/products/"],svnty-cart-completes a[href*="/products/"],' + ww.split(',').map(x => x + ' a[href*="/products/"]').join(',')).forEach(a => { ex[hOf(a.getAttribute('href'))] = 1; });
    $$(ww).forEach(r => (r.dataset.wwHandles || '').split(',').forEach(h => { if (h) ex[h] = 1; }));
    return ex;
  };
  /* S-7 (lane SHEET_S, 2026-09-26): the sheet's own server rail, BEST SELLERS, is the sheet's railEx: PICKED FOR YOU and
     RECENTLY VIEWED in the sheet give up a piece it shows, as the page's roots give up SIMILAR's (D5-5, B-16) */
  const sheetEx = () => { const ex = {}; $$('[data-svnty-sheet-best] a[href*="/products/"]').forEach(a => { ex[hOf(a.getAttribute('href'))] = 1; }); return ex; };
  /* THE HOME'S ROOTS (06:14): a root marked data-svnty-taste-home is a search style root (the profile scores alone)
     that never excludes the page's fifty pieces (railEx would empty the picks) */
  const isHome = r => !!(r && r.hasAttribute && r.hasAttribute('data-svnty-taste-home'));
  /* P9 P2-4: the home row gives up the rail right above it, never the page's fifty */
  const homeEx = root => {
    const ex = {}; let sec = root && root.closest ? root.closest('.shopify-section') : null;
    for (let i = 0; sec && i < 6; i++) { sec = sec.previousElementSibling; const rail = sec && sec.querySelector('[data-svnty-rail]'); if (rail) { $$('a[href*="/products/"]', rail).forEach(a => { ex[hOf(a.getAttribute('href'))] = 1; }); break; } }
    return ex;
  };
  const onPage = root => {
    const sheet = root && home(root) == 'sheet', ex = sheet ? sheetEx() : isHome(root) ? homeEx(root) : railEx(true), rr = root ? recentOf(root) : $('[data-svnty-taste-recent]');
    if (rr) shown(+rr.dataset.svntyMax || 8, sheet ? sheetEx() : isHome(root) ? homeEx(root) : railEx()).forEach(r => { ex[r.h] = 1; });
    st.ev.forEach(e => { if (e.t == 'nope') ex[e.h] = 1; });
    return ex;
  };

  /* PICKED FOR YOU; an impression is half a card on screen for 1 s, once per page (a card never seen was never ignored);
     the second follows the piece, not the node, so a row redrawn under it keeps counting */
  const clock = {};
  const imps = rail => {
    if (rail.__io) rail.__io.disconnect();
    const log = h => { if (seenImp[h] || !$('li[data-svnty-pick="' + h + '"]', rail)) return; seenImp[h] = 1; load(); st.imp.push({ h, ts: now() }); beacon({ t: 'imp', h, ts: now() }); commit(); };
    const lis = $$('li[data-svnty-pick]', rail);
    if (!window.IntersectionObserver) return lis.forEach(li => log(li.dataset.svntyPick));
    rail.__io = new IntersectionObserver(es => es.forEach(x => {
      const h = x.target.dataset.svntyPick;
      if (x.isIntersecting && x.intersectionRatio >= 0.5) { if (!clock[h]) clock[h] = setTimeout(() => { clock[h] = 0; log(h); }, 1000); } else { clearTimeout(clock[h]); clock[h] = 0; }
    }), { threshold: 0.5 });
    lis.forEach(li => rail.__io.observe(li));
  };
  /* S-12 (lane SHEET_S): one fetched card (data-svnty-fetch-pid) is cloned into every root that shows it, so its ids
     ('recent-<pid>', 'recent<pid>') take the root's own token: the page's PICKED pp, RECENT pr, the sheet's sp and sr */
  const tok = root => (home(root) == 'sheet' ? 's' : 'p') + (root.dataset.svntyPicked != null ? 'p' : 'r');
  const sid = (html, root, pid) => pid ? html.split('recent-' + pid).join(tok(root) + '-' + pid).split('recent' + pid).join(tok(root) + pid) : html;
  /* a card of the row: the pick's color, its reason and its "Not for me" */
  const deco = (li, c, root) => {
    const x = li.cloneNode(true), f = $('template[data-svnty-taste-why]', root).content.cloneNode(true), b = $('button', f);
    x.dataset.svntyPick = c.h;
    if (c.want && c.c) want(x, c.c);
    $('dd', f).textContent = c.why || fill('probe_type', { types: lc(c.ty) });
    b.setAttribute('aria-label', b.textContent + ': ' + c.p.ti);
    x.append(f);
    return sid(x.outerHTML, root, x.dataset.svntyFetchPid);
  };
  /* the row waits for the cards it shows; a spare is fetched only when a card of the row has failed (B-25) */
  /* P17-9 (audit P1-7): the page's rails may land while the cards are fetched (COMPLETES YOUR BAG on the bag): the exclusions are
     read again after every wait, and a pick the page now shows gives its seat to the next one */
  const draw = async (root, list, run) => {
    let ex = onPage(root);
    const max = max8(root), pool = list.filter(c => !ex[c.h]).slice(0, max + 4), lis = [];
    const kept = () => lis.filter((li, j) => li && !ex[pool[j].h]).length;
    for (let i = 0; i < pool.length && kept() < max;) {
      const part = pool.slice(i, i += max - kept()).map(c => card(root, c.h, c.vid));
      lis.push(...await Promise.all(part));
      ex = onPage(root);
    }
    if (root.__run != run) return;
    ex = onPage(root);
    const got = pool.filter((c, i) => lis[i] && !ex[c.h]).slice(0, max), row = $('[data-svnty-picked-list]', root), rail = $('[data-svnty-rail]', row);
    $$('[data-svnty-cold]', root).forEach(e => { e.hidden = !root.__learn; });
    root.hidden = got.length < 4 && !root.__learn;
    /* P20-1: the line under the heading is one element and one sentence in every state; only the doors are the learning state's */
    row.hidden = got.length < 4;
    write(rail, got.length < 4 ? '' : got.map(c => deco(lis[pool.indexOf(c)], c, root)).join(''));
    rail.scrollLeft = 0;
    settle(root);
    measure(); imps(rail);
  };
  /** renderPicked(root): 0 events the learning row, 1 or 2 its first 2 or 4 cards as picks, 3 and more on 2 or more
      distinct pieces the picks (filled from the learning row); without consent the same, from this tab's session. */
  const renderPicked = guard('picked', async root => {
    if (!root) return Promise.all(pickedRoots().map(r => renderPicked(r)));
    if (!live(root) || shut(root)) return;
    return renderPickedRoot(root);
  });
  const renderPickedRoot = async root => {
    const run = root.__run = (root.__run || 0) + 1, [I] = await Promise.all([index(), remote()]);
    load();
    if (I && pq.length) { flush(I); commit(); }
    if (root.__run != run) return;
    if (!I) return isHome(root) && !(S.consent && S.consent.keep && S.consent.keep()) ? coldOnly(root) : off(root);
    /* one piece seen, dwelt on and reloaded is still one piece: the personal list needs 2 distinct pieces (B-23) */
    const pieces = new Set(st.ev.filter(e => e.h && /^(view|re|dwell|colour|save|add)$/.test(e.t)).map(e => e.h)).size;
    const n = Math.min(st.ev.filter(e => e.t != 'unsave' && e.t != 'remove').length, pieces < 2 ? 2 : Infinity), ex = onPage(root);
    let picks = n ? rank(I, ex, max8(root) + 4).list.slice(0, n < 3 ? 2 * n : 12) : [];
    /* P9 P2-3: the piece just saved never takes the best seat */
    const fresh = new Set(st.ev.filter(e => e.h && /^(save|add)$/.test(e.t) && now() - (e.ts || 0) < 30 * M).map(e => e.h));
    if (fresh.size) picks = picks.filter(c => !fresh.has(c.h)).concat(picks.filter(c => fresh.has(c.h)).slice(0, 1));
    root.__learn = n < 3;
    /* S-3 (lane SHEET_S): the root is never shown before its cards: draw() writes the heading, the line and the row in one go */
    root.__list = picks.concat(learn(I, ex).filter(c => !picks.some(p => p.h == c.h)));
    return draw(root, root.__list, run);
  };
  /* "Not for me": a negative on the piece and its type; the card gives its seat to the next one of the row, in place, that
     keeps the row's caps (never a third of one type, and not the type just refused); a quiet Undo stays 5 s (B-21) */
  const nope = async li => {
    const root = li.closest('[data-svnty-picked]'), rail = li.parentNode, h = li.dataset.svntyPick;
    const by = {}; (root.__list || []).forEach(c => { by[c.h] = c; });
    const was = by[h] || {};
    load(); push({ t: 'nope', h }); commit();
    const ex = onPage(root), on = $$('li[data-svnty-pick]', rail).map(x => x.dataset.svntyPick).filter(x => x != h);
    const tys = on.map(x => (by[x] || {}).ty);
    undoBar(root, h);
    /* the best seat first: within the caps and not the refused type; then not the refused type; then any piece left */
    const free = c => !ex[c.h] && !on.includes(c.h) && c.h != h;
    const tiers = [c => free(c) && !(was.ty && c.ty == was.ty) && tys.filter(t => t == c.ty).length < 2, c => free(c) && !(was.ty && c.ty == was.ty), free];
    for (const ok2 of tiers) for (const c of root.__list || []) {
      if (!ok2(c)) continue;
      const x = await card(root, c.h, c.vid);
      if (!x) continue;
      const n = node(deco(x, c, root));
      li.replaceWith(n); root.__was = [li, n]; measure(); imps(rail);
      return $('[data-svnty-taste-nope]', n).focus();
    }
    li.remove(); measure();
  };
  /* THE UNDO: a status line under the row, 5 s; the last "not for me" on that piece leaves the profile and the piece takes
     its own seat back (no seat to return to: the row is drawn again) */
  const undoBar = (root, h) => {
    const bar = $('[data-svnty-taste-undo-bar]', root), tpl = $('template[data-svnty-taste-undo]', root);
    if (!bar || !tpl) return;
    clearTimeout(bar.__t);
    bar.innerHTML = ''; bar.append(tpl.content.cloneNode(true));
    bar.dataset.h = h;
    bar.__t = setTimeout(() => { const f = bar.contains(document.activeElement); bar.innerHTML = ''; if (f) try { $('h2', root).focus({ preventScroll: true }); } catch (e) {} }, 5000);
  };
  const undo = btn => {
    const bar = btn.closest('[data-svnty-taste-undo-bar]'), root = btn.closest('[data-svnty-picked]'), h = bar && bar.dataset.h;
    if (!h) return;
    clearTimeout(bar.__t); bar.innerHTML = '';
    load();
    const i = st.ev.map(e => e.t == 'nope' && e.h == h).lastIndexOf(true);
    if (i >= 0) st.ev.splice(i, 1);
    commit(e => e.t == 'nope' && e.h == h);
    const w = root.__was; root.__was = 0;
    if (w && w[0].dataset.svntyPick == h && w[1].isConnected) { w[1].replaceWith(w[0]); measure(); } else renderPicked(root);
    try { $('h2', root).focus({ preventScroll: true }); } catch (e) {}
  };
  /* PEOPLE ALSO VIEWED lands late (Trade fetches it near the viewport): a card it now shows gives its seat to the next */
  const watchAlso = root => {
    const av = $('[data-svnty-also-viewed]');
    if (!av || !window.MutationObserver) return;
    const mo = new MutationObserver(() => {
      if (!$('.svnty-similar__item', av)) return;
      mo.disconnect();
      const ex = onPage(root), rx = railEx(), rr = recentOf(root);
      if ($$('li[data-svnty-pick]', root).some(x => ex[x.dataset.svntyPick])) draw(root, root.__list, root.__run);
      if (rr && $$('li[data-svnty-card-fetch]', rr).some(x => rx[x.dataset.handle])) renderRecent(rr);
    });
    mo.observe(av, { childList: true, subtree: true });
  };

  /* RECENTLY VIEWED */
  /** renderRecent(root): the history's cards newest first, each opening in the color viewed with its Remove, then Clear. */
  const renderRecent = guard('recent', async root => {
    if (!root) return Promise.all(recentRoots().map(r => renderRecent(r)));
    if (!live(root) || shut(root)) return;
    return renderRecentRoot(root);
  });
  const renderRecentRoot = async root => {
    const sheet = home(root) == 'sheet', max = Math.min(12, +root.dataset.svntyMax || 8), run = root.__run = (root.__run || 0) + 1, queue = shown(0, sheet ? sheetEx() : isHome(root) ? {} : railEx()), got = [];
    for (let i = 0; i < queue.length && got.length < max;) {
      const batch = queue.slice(i, i += max - got.length), lis = await Promise.all(batch.map(r => card(root, r.h, r.vid)));
      const pk = {}, pr = pickedOf(root); (pr ? $$('li[data-svnty-pick]', pr) : []).forEach(x => { pk[x.dataset.svntyPick] = 1; });
      lis.forEach((li, j) => { const h = li && li.dataset.handle; if (h && h != pg.h && !pk[h] && got.length < max && !got.some(g => g.h == h)) got.push({ li, r: batch[j], h }); });
    }
    if (root.__run != run) return;
    if (!got.length) return isHome(root) ? emptyRecent(root) : off(root);
    $$('[data-svnty-taste-empty]', root).forEach(e => { e.hidden = true; });
    write($('[data-svnty-rail]', root), got.map(g => {
      const li = g.li.cloneNode(true), b = $('template[data-svnty-taste-remove]', root).content.firstElementChild.cloneNode(true);
      if (g.r.c) want(li, g.r.c, 1);
      b.setAttribute('aria-label', b.textContent + ': ' + (($('.card__heading', li) || {}).textContent || '').trim());
      li.append(b);
      return sid(li.outerHTML, root, li.dataset.svntyFetchPid);
    }).join('') + $('template[data-svnty-taste-end]', root).innerHTML);
    $('[data-svnty-rail]', root).scrollLeft = 0;
    root.hidden = false;
    measure();
  };
  /* Remove: this piece leaves the history (its views and colors too); the next control takes the focus */
  const forget = li => {
    const h = li.dataset.handle, root = li.closest('[data-svnty-taste-recent]'), n = li.nextElementSibling;
    const drop = e => e.h == h && /^(view|re|dwell|colour)$/.test(e.t);
    load(); st.ev = st.ev.filter(e => !drop(e)); commit(drop);
    keep(recent().filter(r => remap(r.h) != h), l => Array.isArray(l) ? l.filter(r => !r || remap(r.h) != h) : null);
    /* the old key, in both stores (B-04) */
    [localStorage, sessionStorage].forEach(x => { try { const l = JSON.parse(x.getItem(K.old)); if (Array.isArray(l)) x.setItem(K.old, JSON.stringify(l.filter(y => !y || y.handle != h))); } catch (e) {} });
    li.remove();
    /* S-10 (lane SHEET_S): the other surface's RECENTLY VIEWED (the page's under the sheet, or the sheet's) forgets it too */
    recentRoots().forEach(r => { if (r !== root) renderRecent(r); });
    if (!$('li[data-svnty-card-fetch]', root)) { if (isHome(root)) emptyRecent(root); else off(root); return head(pickedOf(root)); }
    measure();
    try { $('button[data-svnty-taste-remove],button[data-svnty-taste-clear]', n).focus(); } catch (e) {}
  };
  /* the focus a control hands on when its own row is gone: the heading of PICKED FOR YOU on the same surface */
  const head = r => { try { if (r && !r.hidden) $('h2', r).focus({ preventScroll: true }); } catch (e) {} };
  /** clear(): forgets this device's history and taste (events, impressions, the recent list, the old key, and the dwell
      still pending on this page); both rails react at once: RECENTLY VIEWED hides, PICKED FOR YOU learns anew. */
  const clear = b => {
    /* the surface is read before the rows redraw: the redraw takes the pressed Clear out of the page */
    const onSurface = b && b.closest && pickedOf(b);
    clearInterval(dw);
    load();
    st.ev = []; st.imp = []; seenImp = {};
    commit(true);
    /* Tier 2: the session id and anything queued go with the shopper's history (RECO_TIER2_WIRING section 4) */
    if (S.reco && S.reco.forget) S.reco.forget();
    keep([], () => null);
    /* every copy of the history in both stores (B-04) */
    [localStorage, sessionStorage].forEach(x => { try { x.removeItem(K.old); x.removeItem(K.ob); } catch (e) {} });
    renderRecent(); renderPicked();
    /* S-11 (lane SHEET_S): the focus stays on the surface the Clear was pressed on, never in the closed sheet */
    head(onSurface || pickedRoots()[0]);
  };

  /* THE GRID WATCH (D5-9): facets.js rewrites #ProductGridContainer on every filter; when it empties, a section still in its
     slot is asked again through the Section Rendering API with the page's address (the server decides with the same
     emptiness the grid used) and takes the slot's place; then both rails draw, or hide when the grid has pieces again */
  const slots = () => Promise.all($$('[data-svnty-taste-slot]').map(x => fetch(location.pathname + '?' + new URLSearchParams([...new URLSearchParams(location.search), ['section_id', x.dataset.svntySection]]), { credentials: 'same-origin' })
    .then(r => r.ok ? r.text() : '').then(t => { const n = t && new DOMParser().parseFromString(t, 'text/html').querySelector('[data-svnty-picked],[data-svnty-taste-recent]'); if (n && x.isConnected) x.replaceWith(document.importNode(n, true)); }, () => {})));
  const watchGrid = () => {
    const g = $('#ProductGridContainer');
    if (!g || !$('[data-svnty-taste-slot],[data-svnty-empty-only]')) return;
    let t;
    new MutationObserver(() => { clearTimeout(t); t = setTimeout(guard('grid', async () => {
      if ($('.svnty-empty', g) && $('[data-svnty-taste-slot]')) { await slots(); WORDS = null; readPage(); }
      renderRecent(); renderPicked();
    }), 60); }).observe(g, { childList: true });
  };

  /* BOOT: recording and each rail run apart and guarded, so one failure never takes the others down */
  /** debug(): the storage state (consent flags, events, the history in each store, the last error); ?svnty_taste=debug on a
      product page writes it once to the console and to data-svnty-taste-debug on the rail's root. */
  const debug = () => {
    let c = { api: 0 };
    try { const p = Shopify.customerPrivacy; c = { api: 1, banner: p.shouldShowBanner(), analytics: p.analyticsProcessingAllowed(), preferences: p.preferencesProcessingAllowed ? p.preferencesProcessingAllowed() : null }; } catch (e) {}
    const [l, x] = both(K.rv);
    return { consent: c, gate: S.consent.state, session: mem(), events: st ? st.ev.length : -1, recent: [Array.isArray(l) ? l.length : 0, Array.isArray(x) ? x.length : 0], page: pg.h, error: lastErr };
  };
  const boot = () => {
    /* P17-26 (refuter R2 P3-6): the retired outbox key is purged one more release, here, on a refusal and on Clear: a refusal
       removes what localStorage held (D5-5) */
    try { localStorage.removeItem(K.ob); sessionStorage.removeItem(K.ob); } catch (e) {}
    guard('record', () => { readPage(); load(); migrate(); wishlist(); context(); if (pg.h) { recordView(); dwell(); } commit(); })();
    document.addEventListener('svnty:quickview', guard('quickview', onQuick));
    guard('subscribe', () => { subscribe(PUB_SUB_EVENTS.variantChange, guard('variant', onVariant)); subscribe(PUB_SUB_EVENTS.cartUpdate, guard('cart', onCart)); })();
    guard('door', () => new MutationObserver(ms => ms.forEach(m => { if (m.target.matches && m.target.matches('quick-add-modal')) guard('door', onDoor)(m.target); })).observe(document.body, { subtree: true, attributes: true, attributeFilter: ['open'] }))();
    const go = () => {
      guard('grid', watchGrid)();
      guard('recent', renderRecent)();
      const rs = pickedRoots(), r = rs[0];
      rs.forEach(x => { guard('picked', renderPicked)(x); if (home(x) == 'page') guard('also', watchAlso)(x); });
      if (!rs.length && pq.length) guard('search', () => index().then(I => { if (I) { load(); flush(I); commit(); } }))();
      if (/[?&]svnty_taste=debug/.test(location.search)) setTimeout(() => { const d = JSON.stringify(debug()), host = r || $('[data-svnty-taste-recent]') || document.documentElement; host.setAttribute('data-svnty-taste-debug', d); console.info('svnty-taste ' + d); }, 3000);
    };
    if (window.requestIdleCallback) window.requestIdleCallback(go, { timeout: 1500 }); else setTimeout(go, 200);
  };
  document.addEventListener('pointerdown', e => { lastDown = e.target; }, true);
  document.addEventListener('click', guard('click', e => {
    const t = e.target.closest ? e.target : e.target.parentNode, b = t.closest('[data-svnty-taste-clear],[data-svnty-taste-nope],[data-svnty-taste-remove],[data-svnty-taste-undo]'), a = !b && t.closest('a[href*="/products/"]');
    if (b) {
      e.preventDefault();
      if (b.dataset.svntyTasteUndo != null) guard('undo', undo)(b); else if (b.dataset.svntyTasteNope != null) guard('nope', nope)(b.closest('li')); else if (b.dataset.svntyTasteRemove != null) guard('remove', forget)(b.closest('li')); else guard('clear', clear)(b);
    }
    if (a) put(K.via, { h: hOf(a.getAttribute('href')), ts: now(), r: ['picked', 'taste-recent', 'similar', 'look', 'also-viewed'].find(k => a.closest('[data-svnty-' + k + ']')) || 'page' }, 1);
  }), true);
  document.addEventListener('svnty:wishlist:change', guard('wishlist', () => {
    load();
    const ch = wishlist();
    commit();
    /* a save on the page refreshes the rows; a heart tapped inside PICKED FOR YOU never moves that row under the finger */
    if (ch) pickedRoots().forEach(r => { if (!(lastDown && r.contains(lastDown))) { clearTimeout(r.__t); r.__t = setTimeout(guard('picked', () => renderPicked(r)), 350); } });
    lastDown = null; /* P9 P2-1: read once */
  }));
  /* THE GATE ANSWERS (D5-5): yes folds this tab's profile and history into localStorage; no removes what localStorage
     held (the visit keeps its session copy); pending changes nothing */
  S.consent.on(guard('consent', state => {
    if (state == 'yes') {
      load(); const l = recent(); commit(); keep(l);
      /* P9 P1-2: a row drawn before the gate answered never asked the server; ask now and redraw (only then: D10-3c) */
      if (remoteMissed) { remoteMissed = false; remoteKey = ''; remoteAt = 0; pickedRoots().forEach(r => { clearTimeout(r.__t); r.__t = setTimeout(guard('picked', () => renderPicked(r)), 350); }); }
    }
    else if (state == 'no') [K.st, K.rv, K.ob, K.old].forEach(k => { try { localStorage.removeItem(k); } catch (e) {} });
  }));
  /* P17-9 (audit P1-7): COMPLETES YOUR BAG answered on the bag: a pick it now shows gives its seat (never under the finger) */
  document.addEventListener('svnty:completes:ready', guard('completes', () => pickedRoots().forEach(r => {
    if (!r.__list || r.hidden || (lastDown && r.contains(lastDown))) return;
    const ex = onPage(r);
    if ($$('li[data-svnty-pick]', r).some(x => ex[x.dataset.svntyPick])) draw(r, r.__list, r.__run);
  })));
  /* WEAR IT WITH showed another colour's row: RECENTLY VIEWED gives up any piece that row now shows (B-16) */
  document.addEventListener('svnty:look:row', guard('look', () => { const rx = railEx(); recentRoots().forEach(r => { if (home(r) == 'page' && $$('li[data-svnty-card-fetch]', r).some(x => rx[x.dataset.handle])) renderRecent(r); }); }));
  window.addEventListener('pageshow', guard('pageshow', e => { if (e.persisted) { load(); return renderRecent(); } }));
  document.addEventListener('shopify:section:load', guard('editor', () => { WORDS = null; readPage(); renderPicked(); renderRecent(); }));

  /* THE PUBLIC FACE: clear(), index(), beacon(e), events() the log, profile() and rank(n) as promises, refresh() every rail,
     arm(host) the lazy roots inside host (D8-2: the search sheet's) drawn now and on every later refresh */
  Object.assign(T, {
    beacon, clear, index, debug,
    arm: host => Promise.resolve(null).then(() => { const rs = $$('[data-svnty-picked],[data-svnty-taste-recent]', host || document); rs.forEach(r => { r.__armed = 1; }); return Promise.all(rs.map(r => r.dataset.svntyPicked != null ? renderPicked(r) : renderRecent(r))); }),
    events: () => (load(), st.ev.slice()),
    profile: () => index().then(I => (load(), I && profile(I))),
    rank: n => index().then(I => (load(), I && rank(I, onPage(), n || 12))),
    refresh: () => Promise.all([renderPicked(), renderRecent()])
  });
  if (document.readyState == 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
